import { render, staticRenderFns } from "./add.vue?vue&type=template&id=25082bcc&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25082bcc')) {
      api.createRecord('25082bcc', component.options)
    } else {
      api.reload('25082bcc', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=25082bcc&", function () {
      api.rerender('25082bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/estateManagement/partyBuilding/businessGuide/add.vue"
export default component.exports